<!-- ═══════════════════════════════════════════════
     HOME PAGE — D-MED EXPRESS ORIGINAL INNOVATION
     ═══════════════════════════════════════════════ -->
<div class="dmed-home">

  <!-- ─── INNOVATIVE HERO ─── -->
  <section class="hero-innovation">
    <div class="ambient-glow glow-teal"></div>
    <div class="ambient-glow glow-copper"></div>
    
    <div class="container hero-grid">
      <!-- Left Content -->
      <div class="hero-content fade-in-up">
        <div class="badge-pill">
          <span class="pulse-dot"></span> Santé & Innovation
        </div>
        
        <h1 class="hero-title">
          Vos médicaments à portée de main, <br>
          <span class="text-copper">sans vous déplacer.</span>
        </h1>
        
        <p class="hero-subtitle">
          La première pharmacie digitale qui s'adapte à votre rythme. Transmettez votre ordonnance, validez le devis, et recevez votre traitement en un temps record via nos pharmacies partenaires agréées.
        </p>
        
        <div class="hero-action-group">
          <a routerLink="/prescription/upload" class="btn-main-glow">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
            Transmettre une ordonnance
          </a>
          <a routerLink="/catalog" class="btn-text-link">
            Parcourir le catalogue <span class="arrow">→</span>
          </a>
        </div>
      </div>
      
      <!-- Right Visual (Glassmorphism) -->
      <div class="hero-visual fade-in-up delay-1">
        <div class="glass-stage">
          <img src="assets/images/hero-courier.png" alt="Livreur D-Med" class="courier-hero-img">
          
          <!-- Floating UI Elements -->
          <div class="float-ui ui-top-left">
            <div class="ui-icon green-icon">✓</div>
            <div class="ui-text">Pharmacies<br><strong>Certifiées</strong></div>
          </div>
          
          <div class="float-ui ui-bottom-right">
            <div class="ui-icon copper-icon">⚡</div>
            <div class="ui-text">Livraison<br><strong>Rapide</strong></div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Overlapping Trust Cards -->
    <div class="container overlap-trust-container fade-in-up delay-2">
      <div class="trust-cards-wrapper">
        <div class="trust-card">
          <span class="t-icon">🔒</span>
          <div class="t-info">
            <strong>Sécurité Totale</strong>
            <span>Données médicales cryptées</span>
          </div>
        </div>
        <div class="divider"></div>
        <div class="trust-card">
          <span class="t-icon">⏱️</span>
          <div class="t-info">
            <strong>Gain de temps</strong>
            <span>Évitez les files d'attente</span>
          </div>
        </div>
        <div class="divider"></div>
        <div class="trust-card">
          <span class="t-icon">💳</span>
          <div class="t-info">
            <strong>Paiement Flexible</strong>
            <span>Mobile Money ou espèces</span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ─── HORIZONTAL TIMELINE (Comment ça marche) ─── -->
  <section class="timeline-section">
    <div class="container">
      <div class="section-header text-center">
        <h2>Un parcours fluide en <span class="text-teal">3 étapes</span></h2>
        <p>Nous avons repensé l'accès aux soins pour le rendre le plus simple possible.</p>
      </div>
      
      <div class="timeline-wrapper">
        <!-- Ligne de connexion -->
        <div class="timeline-line"></div>
        
        <div class="timeline-grid">
          <!-- Step 1 -->
          <div class="time-step">
            <div class="step-marker">01</div>
            <div class="step-card">
              <div class="step-icon">📸</div>
              <h3>Capturez & Envoyez</h3>
              <p>Prenez votre ordonnance en photo via notre interface sécurisée en quelques secondes.</p>
            </div>
          </div>
          
          <!-- Step 2 -->
          <div class="time-step">
            <div class="step-marker">02</div>
            <div class="step-card">
              <div class="step-icon">📋</div>
              <h3>Validation & Devis</h3>
              <p>Notre réseau de pharmaciens vérifie la prescription et vous soumet un devis transparent.</p>
            </div>
          </div>
          
          <!-- Step 3 -->
          <div class="time-step">
            <div class="step-marker">03</div>
            <div class="step-card">
              <div class="step-icon">🛵</div>
              <h3>Livraison Express</h3>
              <p>Un coursier dédié récupère vos médicaments et vous les livre discrètement où que vous soyez.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ─── BENTO BOX (Pourquoi Choisir D-Med) ─── -->
  <section class="bento-section">
    <div class="container">
      <div class="section-header">
        <h2>L'excellence au service de <br>votre <span class="text-copper">santé</span></h2>
      </div>
      
      <div class="bento-grid">
        <!-- Large Card 1 -->
        <div class="bento-card bento-large teal-bg">
          <img src="assets/images/bento-pharmacy.png" alt="Réseau de pharmacies" class="bento-bg-img">
          <div class="bento-overlay"></div>
          <div class="bento-content">
            <h3>Le plus grand réseau de pharmacies de confiance</h3>
            <p>Nous collaborons exclusivement avec des officines rigoureusement sélectionnées et agréées par l'ordre national.</p>
          </div>
        </div>
        
        <!-- Small Card 1 -->
        <div class="bento-card bento-small with-img">
          <img src="assets/images/bento-support.png" alt="Support H24" class="bento-img-small">
          <div class="bento-content">
            <h3>Support H24</h3>
            <p>Une assistance toujours à votre écoute.</p>
          </div>
        </div>
        
        <!-- Small Card 2 -->
        <div class="bento-card bento-small with-img">
          <img src="assets/images/bento-tracking.png" alt="Suivi en direct" class="bento-img-small">
          <div class="bento-content">
            <h3>Suivi en direct</h3>
            <p>Géolocalisation de votre livreur en temps réel.</p>
          </div>
        </div>
        
        <!-- Wide Card -->
        <div class="bento-card bento-wide dark-bg">
          <div class="bento-content">
            <h3>Discrétion Absolue</h3>
            <p>Vos commandes sont emballées dans des paquets opaques et scellés. Le secret médical est notre priorité absolue.</p>
          </div>
          <img src="assets/images/bento-discretion.png" alt="Discrétion absolue" class="bento-img-wide">
        </div>
      </div>
      
      <!-- Mention légale élégante -->
      <div class="legal-mention">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
        <span><strong>Plateforme d'intermédiation :</strong> D-Med Express ne vend pas de médicaments, nous facilitons uniquement la connexion entre vous et les pharmacies.</span>
      </div>
    </div>
  </section>

  <!-- ─── MODERN OFFSET CTA ─── -->
  <section class="offset-cta-section">
    <div class="container">
      <div class="cta-box-modern">
        
        <div class="cta-text-content">
          <h2>Prenez soin de votre famille, <br>nous nous occupons du reste.</h2>
          <p>Rejoignez les milliers de patients qui ont déjà simplifié leur accès aux soins grâce à D-Med Express.</p>
          
          <ul class="cta-check-list">
            <li>✓ Inscription gratuite</li>
            <li>✓ Sans engagement</li>
            <li>✓ Service client réactif</li>
          </ul>
          
          <a routerLink="/prescription/upload" class="btn-main-glow copper-glow mt-4">
            Commencer maintenant
          </a>
        </div>
        
        <div class="cta-image-wrapper">
          <img src="assets/images/family-health.png" alt="Famille en santé" class="family-cta-img">
          <!-- Glass overlay -->
          <div class="glass-overlay">
            <span class="stars">★★★★★</span>
            <span class="review-text">"Un service qui a changé notre quotidien !"</span>
          </div>
        </div>
        
      </div>
    </div>
  </section>

</div>
